import { useRouter } from 'next/router';
import React, { useEffect, useState } from "react";

import theme from "../../../config/theme";

import Icon from 'react-icons-kit';
import { x } from 'react-icons-kit/feather';
import Api from '../../../utils/api';
import Filters from "../../blocks/Filters";
import GridHead from "../../blocks/GridHead";
import ProductGrid from "../../blocks/ProductGrid/ProductGrid";
import ButtonV2 from "../../elements/Base/ButtonV2";
import WidthWrapper from "../../elements/Base/WidthWrapper";
import Pagination from "../../elements/Pagination";

export const onFilterChange = async (params) => {
    const url = params.view === "singles" || params.view === 'singles-search' ? `/public/cards` : `/public/products`;

    const opts = {
        page: params.page < 1 ? 1 : params.page,
        pageSize: params.pageSize < 12 ? (params.pageSize > 48 ? 48 : params.pageSize) : 24,
        category: params.category,
        filters: params.filters,
        search: params.search || '',
        sort: params.sort,
        sortDirection: params.sortDirection,
        view: params.view || null,
        game: params.game
    }

    const apiResponse = await Api.get(url, {}, opts);

    return {
        query: params.search,
        breadcrumbs: apiResponse.data.breadcrumbs,
        products: apiResponse.data.products,
        category: apiResponse.data.category,
        filters: apiResponse.data.filters,
        total: apiResponse.data.total
    }
}

const ProductListPage = (props) => {
    const router = useRouter();

    const [ products, setProducts ] = useState(props.products);
    const [ filters, setFilters ] = useState(props.filters);
    const [ total, setTotal ] = useState(props.total);
    const [ showFilter, setShowFilter ] = useState(true);
    const [ filterState, setFilterState ] = useState(props.filterState);
    const [ pageState, setPageState ] = useState(props.page);
    const [ sortState, setSortState ] = useState(props.sort)
    const [ controlsEnabled, setControlsEnabled ] = useState(true);

    useEffect(() => {
        setProducts(props.products);
        setFilters(props.filters);
        setTotal(props.total);
        setFilterState(props.filterState);
        setPageState(props.page);
        setSortState(props.sort);
    }, [props.products, props.filters, props.total, props.filterState, props.page, props.sort])

    function getNextPageUrl(filterState, page, sort) {
        const opts = {
            page: page + 1,
            pageSize: props.pageSize,
            category: props.category ? props.category.slug : null,
            search: props.query || '',
            sort,
            game: props.game
        };

        const reqFilterState = cleanFilterState(filters, filterState);

        opts.filters = reqFilterState;

        if(props.view === 'search') {
            return getUrl('/cautare/' + props.query ,opts);
        } else if(props.view === 'singles') {
            return getUrl('/singles/', opts);
        } else if(props.view === 'singles-search') {
            return getUrl('/cautare-singles/' + props.query, opts);
        } else if(props.view === 'category') {
            return getUrl('/categorie/' + props.category.slug ,opts);
        } else {
            return getUrl('/toate-produsele/', opts);
        }
    }

    function getPrevPageUrl(filterState, page, sort) {
        const opts = {
            page: page - 1,
            pageSize: props.pageSize,
            category: props.category ? props.category.slug : null,
            search: props.query || '',
            sort,
            game: props.game
        };


        if(props.view === 'search') {
            return getUrl('/cautare/' + props.query ,opts);
        } else if(props.view === 'singles') {
            return getUrl('/singles/', opts);
        } else if(props.view === 'singles-search') {
            return getUrl('/cautare-singles/' + props.query, opts);
        } else if(props.view === 'category') {
            return getUrl('/categorie/' + props.category.slug ,opts);
        } else {
            return getUrl('/toate-produsele/', opts);
        }
    }

    async function fetchData(filterState, page, sort, view) {
        setControlsEnabled(false);
        window.scrollTo({top: 0, behavior: 'smooth'});

        const opts = {
            page,
            pageSize: props.pageSize,
            category: props.category ? props.category.slug : null,
            search: props.query || '',
            sort,
            game: props.game
        };

        const reqFilterState = cleanFilterState(filters, filterState);



        opts.filters = reqFilterState;

        let hasCategoryFilter = false;

        for(let i in opts.filters) {
            if(opts.filters[i].id === 'categories') {

                opts.filters = opts.filters.filter(f => !(f.id === 'categories' && f.value && f.value[0] === ''))

                hasCategoryFilter = true;
                opts.category = null;
            }
        }

        if(props.view === 'search') {
            router.push(getUrl('/cautare/[query]', opts), getUrl('/cautare/' + props.query ,opts), { shallow: false }).then(() => {
                setControlsEnabled(true);
            });
        } else if(props.view === 'singles') {
            router.push(getUrl('/singles/', opts), getUrl('/singles/' ,opts), { shallow: false }).then(() => {
                setControlsEnabled(true);
            });
        } else if(props.view ==='singles-search') {
            router.push(getUrl('/cautare-singles/' + props.query, opts), getUrl('/cautare-singles/' + props.query ,opts), { shallow: false }).then(() => {
                setControlsEnabled(true);
            });
        } else if(props.view === 'category' && !hasCategoryFilter) {
            router.push(getUrl('/categorie/[slug]', opts), getUrl('/categorie/' + props.category.slug ,opts), { shallow: false }).then(() => {
                setControlsEnabled(true);
            });
        } else {
            router.push(getUrl('/toate-produsele/', opts), getUrl('/toate-produsele/', opts), {shallow: false}).then(() => {
                setControlsEnabled(true);
            });
        }

    }

    const handleChange = async (params) => {
        let currentFilter = filterState.find(filter => {
            return params.id === filter.id;
        })

        let tmpFilterState = filterState.filter(filter => {
            return params.id !== filter.id
        });

        if(params.checked) {
            if(currentFilter) {
                if(currentFilter.value.indexOf(params.value) === -1) {
                    currentFilter.value.push(params.value);
                }
            } else {
                currentFilter = {
                    id: params.id,
                    value: [params.value]
                };
            }
        } else {
            if(currentFilter) {
                if(currentFilter.value.indexOf(params.value) !== -1) {
                    currentFilter.value = currentFilter.value.filter(value => value !== params.value);
                }
            }
        }

        if(currentFilter) {
            if(currentFilter.id === "categories") {
                currentFilter.value = [currentFilter.value[currentFilter.value.length - 1]];
            }

            tmpFilterState.push(currentFilter);
        }

        setFilterState(tmpFilterState);
        setPageState(1);
        await fetchData(tmpFilterState, 1, sortState, props.view);
    }

    const clearFilters = async () => {
        const remainingFilters = [];
        for(let i in filterState) {
            if(filterState[i].id === "categories") {
                remainingFilters.push(filterState[i]);
            }
        }

        setFilterState(remainingFilters);
        setPageState(1);
        await fetchData(remainingFilters, 1, sortState, props.view);
    }

    const cleanFilterState = (f, fState) => {
        const requestFilterState = [];
        for(let i in fState) {
            let currentFState = { id: fState[i].id, value: []};

            for(let j in fState[i].value) {
                let found = false;

                for(let k in f) {
                    for(let l in f[k].counts) {
                        if(f[k].textId == fState[i].id && f[k].counts[l].value === fState[i].value[j]) {
                            currentFState.value.push(f[k].counts[l].value);
                            found = true;
                            break;
                        }
                    }

                    if(found === true) {
                        break;
                    }
                }
            }

            if(currentFState.value.length > 0) {
                requestFilterState.push(currentFState);
            }
        }

        return requestFilterState;
    }

    const sortFilters = (filters) => {
        for(let i in filters) {
            if(filters[i].id === 'categories') {
                continue;
            }
            filters[i].counts = filters[i].counts.sort((a, b) => {
                return a.status === true ? -1 : b.status === true ? 1 : 0;
            })
        }
    }

    function getUrl(base, opts) {
        let url = base;

        let components = [];

        if(opts.page) {
            components.push(['page', encodeURIComponent(opts.page)]);
        }

        if(opts.sort) {
            components.push(['sort', encodeURIComponent(opts.sort)]);
        }

        if(opts.game) {
            components.push(['game', encodeURIComponent(opts.game)]);
        }

        if(opts.filters) {
            opts.filters.forEach(filter => {
                components.push(['filters', encodeURIComponent(filter.id + '_' + filter.value.join(';'))]);
            });
        }

        if(components.length > 0) {
            components = components.map(component => `${component[0]}=${component[1]}`).join('&');
            url += '?' + components;
        }

        return url;
    }

    const handlePageChange = async (page) => {
        if(page < 1) {
            return;
        }

        fetchData(filterState, page, sortState, props.view);
        setPageState(page);
    }

    const handleSortChange = async (sort) => {
        setPageState(1);
        fetchData(filterState, 1, sort, props.view);
        setSortState(sort);
    }

    const handleFilterToggle = () => {
        setShowFilter(!showFilter);
    }

    return (
        <WidthWrapper>
            <div className={`search-wrapper ${!showFilter ? 'schroedingers-hidden' : ''}`}>
                <style jsx>{`
                    .search-wrapper {
                        display: flex;
                        width: 100%;
                        box-sizing: border-box;
                    }

                    .filter-wrapper {
                        margin-top: 10px;
                        max-width: 250px;
                        width: 100%;
                        margin-right: 10px;
                        overflow:hidden;
                        transition: max-width 0.2s ease-out;
                    }

                    .schroedingers-hidden .filter-wrapper {
                        max-width: 0px;
                        margin-right: 0px;
                    }

                    .filter-box {
                        min-width: 250px;
                    }

                    .product-wrapper {
                        flex-grow: 1;
                        flex-shrink: 1;
                        display: flex;
                        flex-direction: column;
                        margin-top: 10px;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        transition: all 0.2s ease-out;
                    }

                    .schroedingers-hidden .product-wrapper {
                        margin-top: 0px;
                        margin-right: 0px;
                    }

                    .product-grid-wrapper {
                        transition: all 0.2s ease-out;
                    }

                    .schroedingers-hidden .product-grid-wrapper {
                        margin: 10px;
                    }

                    .mobile-filter-header {
                        display: none;
                    }

                    .category-image {
                        width: 100%;
                        height: 200px;
                        display: block;
                        background-size: 100%;
                        background-position: center;
                        background-image: url('${process.env.imageStorage}/category_image_default_${props.category ? props.category.image : ''}.jpg');
                    }

                    .category-label {
                        background-color: ${theme.colors.base.black};
                        color: ${theme.colors.base.white};
                        font-weight: 900;
                        text-transform: uppercase;
                        padding: 10px;
                    }

                    @media only screen and (max-width: ${theme.responsive.m}px) {
                        .filter-wrapper{
                            max-width: 0px;
                            position: fixed;
                            margin: 0px;
                            left: 0px;
                            right: 0px;
                            top: 50px;
                            bottom: 0px;
                            z-index: 900;
                            background-color: white;
                            overflow: hidden;
                            max-height: calc(100% - 50px);
                            box-shadow: 5px 0px 10px rgba(0,0,0,0.1);
                        }

                        .schroedingers-hidden .filter-wrapper {
                            max-width: 100%;
                        }

                        .filter-box {
                            overflow-y: scroll;
                            overscroll-behavior: contain;
                            max-height: calc(100vh - 90px);
                        }

                        .product-grid-wrapper {
                            margin: 10px;
                        }

                        .product-wrapper {
                            margin: 0;
                        }

                        .mobile-filter-header {
                            width: 100%;
                            background: linear-gradient(to right,${theme.colors.gradients.darkA} 10%,${theme.colors.gradients.darkB});
                            color: ${theme.colors.base.white};
                            align-items: center;
                            display: flex;
                            height: 48px;
                            padding-left: 10px;
                            margin-bottom: 10px;
                            justify-content: space-between;
                            z-index: 1000;
                            box-sizing: border-box;
                        }

                    }

                    .no-products {
                        height: 400px;
                        font-weight: 900;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-transform: uppercase;
                        width: 100%;
                        padding: 20px;
                        box-sizing: border-box;
                        opacity: 0.4;

                        font-size: 3rem;
                    }

                    .min-width-button {
                        min-width: 42px;
                        margin-right: 5px;
                    }

                `}</style>

                    <div className={`filter-wrapper`}>
                        <div className="mobile-filter-header min-width-button">
                            Filtre
                            <div className="min-width-button">
                                <ButtonV2 type="red" shadow={false} padding={false} rounded={false} onClick={() => setShowFilter(!showFilter)}>
                                    <Icon size={24} icon={x}/>
                                </ButtonV2>
                            </div>
                        </div>
                        <div className="filter-box">
                            <Filters enabled={controlsEnabled} filters={filters} onChange={handleChange} clearFilters={clearFilters} view={props.view}/>
                        </div>
                    </div>
                        <div className="product-wrapper">
                                    <GridHead query={props.query}
                                        view={props.view}
                                        category={props.category}
                                        sort={sortState}
                                        onSortChange={handleSortChange}
                                        onFilterToggle={handleFilterToggle}
                                        showFilter={showFilter}
                                    />
                                <div className="product-grid-wrapper">
                                    {products.length === 0 ?
                                        <div className="no-products">
                                            Nu am gasit produse
                                        </div>
                                    : null}
                                    <ProductGrid products={products} enabled={controlsEnabled} type={props.view || 'products'} />
                                </div>

                                {products.length > 0 ?
                                    <Pagination pagination={{
                                            page: pageState,
                                            pageSize: 24,
                                            total: total
                                        }}
                                        nextPage={getNextPageUrl(filterState, pageState, sortState)}
                                        prevPage={getPrevPageUrl(filterState, pageState, sortState)}
                                        onPageChange={handlePageChange}
                                    /> : null}
                        </div>
            </div>
        </WidthWrapper>
    )
}

export default ProductListPage;
